import "../index.css"

export default function BlogCard({ data, removeBlog }) {
    return (
        <div className="blog-card">
            <h3>{data.title}</h3>
            <p>{data.content}</p>
            <button className="remove" onClick={() => removeBlog(data.id)}>Remove</button>
            {/* <hr /> */}
        </div>
    );
}
